//@ts-nocheck

'use client'

import React from 'react'
import * as S from './BentoBox.styles'
import { ButtonForwardingRef } from '../../atoms/Button/Button.component'
import { Container } from '../../atoms/GridSystem'
import Box from '../../molecules/Box/Box.component'
import useMediaQuery from '../../../hooks/useMediaQuery'
import useSwiperRef from '../../../hooks/useSwiperRef'
import { A11y, Navigation, Scrollbar } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

interface BoxItem {
  id?: string | number
  [key: string]: any
}

interface MobileCarouselProps {
  items: BoxItem[]
}

interface BentoBoxProps {
  items: BoxItem[]
  itemsLength: number
  sectionId?: string
  bentosCardAlignment?: string
  isCarousel?: boolean
}

const MobileCarousel: React.FC<MobileCarouselProps> = ({ items }) => {
  const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>()
  const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>()
  const [scrollbarEl, scrollbarElRef] = useSwiperRef<HTMLDivElement>()

  return (
    <div>
      <S.SwiperWrapper>
        <Swiper
          modules={[Navigation, Scrollbar, A11y]}
          spaceBetween={28}
          slidesPerView={1}
          navigation={{
            prevEl,
            nextEl,
          }}
          scrollbar={{ el: scrollbarEl }}
          a11y={{
            prevSlideMessage: 'Slide precedente',
            nextSlideMessage: 'Slide successiva',
          }}
          grabCursor={true}
        >
          {items.map((item, i) => (
            <SwiperSlide key={`BentoBox-Item-${i}-${item?.id}`}>
              <Box {...item} isBentoBox />
            </SwiperSlide>
          ))}
        </Swiper>
        { items.length > 1 ? (
          <>
            <S.Navigation>
              <S.ButtonPrev>
                <ButtonForwardingRef
                  ref={prevElRef}
                  variant="secondary"
                  iconEnd={'chevron-left'}
                  iconEndSize="big"
                />
              </S.ButtonPrev>
              <S.ButtonNext>
                <ButtonForwardingRef
                  ref={nextElRef}
                  variant="secondary"
                  iconEnd={'chevron-right'}
                  iconEndSize="big"
                />
              </S.ButtonNext>
            </S.Navigation>
            <S.NavScrollbar ref={scrollbarElRef} />
          </>
        ) : null}
      </S.SwiperWrapper>
    </div>
  )
}

const BentoBox: React.FC<BentoBoxProps> = ({
  items,
  itemsLength,
  sectionId,
  bentosCardAlignment = 'full',
  isCarousel = false,
}) => {
  const isMobile = useMediaQuery('(max-width: 575px)')

  const renderBoxes = (bentosCardAlignment: string) => {
    if (itemsLength === 0) return <></>
    if (isMobile && isCarousel) return <MobileCarousel items={items} />
    return items.map((item, index) => (
      <Box key={`bento-box-${index}`} {...item} isBentoBox bentosCardAlignment={bentosCardAlignment}/>
    ))
  }

  return (
    <Container as="section" id={sectionId}>
      <S.BentoBoxWrapper $bentosCardAlignment={bentosCardAlignment}>
        {renderBoxes(bentosCardAlignment)}
      </S.BentoBoxWrapper>
    </Container>
  )
}

export default BentoBox
